module.exports = __webpack_public_path__ + "static/opa-5c7feea545ad798dd005534f67e589dc.jpg";